import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";
@Injectable()
export class ClearJunctionService {
    token: string;
    api_url: string = environment.apiEndPoint;

    constructor(private http: HttpClient) { }
    getToken() {
        if (!this.token)
            this.token = localStorage.getItem(environment.TOKEN_SECRET);
        return this.token;
    }
    getClearJunctionAudit(filter: any) {
        const configs = {
            withCredentials: true,
            headers: { Authorization: `Bearer ${this.getToken()}` },
        };
        return this.http.post<any>(this.api_url + 'getclearjunctionaudit', filter, configs)
    }
    getClearJunctionTransactions(filter: any) {
        const configs = {
            withCredentials: true,
            headers: { Authorization: `Bearer ${this.getToken()}` },
        };
        return this.http.post<any>(this.api_url + 'clear-junction-transactions', filter, configs)
    }
    saveClearJunctionTransactions(updateData: any) {
        const configs = {
            withCredentials: true,
            headers: { Authorization: `Bearer ${this.getToken()}` },
        };
        return this.http.post<any>(this.api_url + 'save-clear-junction-transactions', updateData, configs)
    }
}


// WEBPACK FOOTER //
// ./src/app/services/clearjunction.service.ts